// extracted by mini-css-extract-plugin
export default {"floating-telegram-button":"FloatingTelegramButton_floating-telegram-button__iiAbq"};